webpackJsonp([92],{

/***/ "1ps6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/section-company-quote_0237d771edd51d18de20f39a3f64eef7.html";

/***/ }),

/***/ "ukZq":
/***/ (function(module, exports, __webpack_require__) {

var SectionCompanyQuote = (function () {
    function SectionCompanyQuote() {
    }
    return SectionCompanyQuote;
}());
angular.module('animatronApp.sectionCompanyQuote', []).component('sectionCompanyQuote', {
    bindings: {
        username: '<',
        description: '<',
        text: '<',
        avatar: '<',
        alt: '<'
    },
    controller: SectionCompanyQuote,
    templateUrl: __webpack_require__("1ps6")
});


/***/ })

});


// WEBPACK FOOTER //
// javascripts/92-257c10c0995a4d25fa59.min.js